import { useState, useEffect } from "react";
import { useVendorAuth } from "../../store/vendorAuthStore";
import { vendorApi } from "../../services/vendorApi";
import "./Wallet.css";

export default function RequestPayout() {
  const { token } = useVendorAuth();
    const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [walletLoading, setWalletLoading] = useState(true);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [wallet, setWallet] = useState(null);

  /* =========================
     FETCH WALLET
  ========================= */
  useEffect(() => {
    const fetchWallet = async () => {
      try {
        setWalletLoading(true);
        const response = await vendorApi.wallet(token);
        if (response && response.success) {
          setWallet({
            balance: response.balance || 0,
            pending: response.pending || 0,
            wallet_amount: response.wallet_amount || 0,
            accepted: response.accepted || 0,
          });
          setErr("");
        } else {
          setErr("Failed to load wallet. Please refresh.");
        }
      } catch (error) {
        console.error(error);
        setErr("Failed to load wallet. Please refresh.");
      } finally {
        setWalletLoading(false);
      }
    };
    if (token) fetchWallet();
  }, [token]);

  /* =========================
     VALIDATION
  ========================= */
  const validateAmount = () => {
    const num = Number(amount);
    if (!amount || num <= 0) {
      setErr("Enter a valid amount.");
      return false;
    }
    if (wallet && num > wallet.balance) {
      setErr("Amount exceeds your available balance.");
      return false;
    }
    return true;
  };

  /* =========================
     SUBMIT
  ========================= */
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setOk("");
    if (!validateAmount()) return;
    setLoading(true);
    try {
      await vendorApi.requestPayout(token, Number(amount));
      setOk("Request sent successfully. Admin will approve 👍");
      setAmount("");
    } catch (error) {
      console.error(error);
      setErr(
        error?.response?.data?.message ||
          "Payout request failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     LOADING
  ========================= */
  if (walletLoading) {
    return <div className="pw-page">Loading...</div>;
  }

  return (
    <div className="pw-page">
      <h2>Request Payout</h2>

      {/* WALLET */}
      {wallet && (
        <div className="pw-wallet-card">
          <p>Available: ₹{wallet.balance}</p>
          <p>Pending: ₹{wallet.pending}</p>
        </div>
      )}

      {/* ERROR */}
      {err && <div className="pw-alert pw-alert-err">{err}</div>}

      {/* SUCCESS */}
      {ok && <div className="pw-alert pw-alert-ok">{ok}</div>}

      {/* FORM */}
      <form onSubmit={submit}>
        <input
          type="number"
          value={amount}
          min="1"
          max={wallet?.balance ?? undefined}
          onChange={(e) => {
            setAmount(e.target.value);
            setErr("");
            setOk("");
          }}
          placeholder="Enter amount"
          required
        />
        <br />
        <br />
        <button type="submit" disabled={loading || !amount}>
          {loading ? "Submitting..." : "Request Payout"}
        </button>
      </form>
    </div>
  );
}